import React from 'react';
import HeroSection from './HeroSection';
import FeatureGrid from './FeatureGrid';
import LoginForm from './LoginForm';
import '../../styles/landing.css';

/**
 * LandingPage — Gateway to MinuteWinIt.
 * Composes: HeroSection, FeatureGrid, LoginForm, Footer.
 */
const LandingPage = ({ onEnter }) => (
    <div className="landing-bg min-h-screen text-white">
        {/* Top Bar */}
        <nav className="relative z-10 flex justify-between items-center px-8 py-6">
            <div className="flex items-center gap-3">
                <img src="/logo-icon.png" alt="" className="w-7 h-7" />
                <span className="text-sm tracking-[0.15em] uppercase font-semibold text-white/90 flex items-center gap-1.5">
                    <span>Minute</span>
                    <span>Market</span>
                </span>
            </div>
            <button
                onClick={() => document.getElementById('login-section')?.scrollIntoView({ behavior: 'smooth' })}
                className="px-5 py-2 rounded-lg text-[10px] uppercase tracking-[0.2em] font-bold transition-all border border-white/10 text-white/70 hover:text-white hover:border-white/25 hover:bg-white/[0.04]"
            >
                Sign In
            </button>
        </nav>

        <HeroSection />
        <FeatureGrid />
        <LoginForm onEnter={onEnter} />

        {/* Footer */}
        <footer className="relative z-10 py-12 px-8">
            <div className="landing-divider mb-8" />
            <div className="flex flex-col md:flex-row justify-between items-center gap-4 max-w-5xl mx-auto">
                <div className="text-[10px] text-slate-700 tracking-[0.15em] uppercase font-medium">
                    © 2025 MinuteMarket
                </div>
                <div className="flex gap-8">
                    {['Terms', 'Privacy', 'Docs'].map(link => (
                        <span key={link} className="text-[10px] text-slate-700 tracking-[0.15em] uppercase font-medium hover:text-slate-400 cursor-pointer transition-colors">
                            {link}
                        </span>
                    ))}
                </div>
            </div>
        </footer>
    </div>
);

export default LandingPage;
